import { render } from "./Upload.vue?vue&type=template&id=2161c7e2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2161c7e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2161c7e2', __exports__)) {
    api.reload('2161c7e2', __exports__)
  }
  
  module.hot.accept("./Upload.vue?vue&type=template&id=2161c7e2", () => {
    api.rerender('2161c7e2', render)
  })

}


export default __exports__